import { render } from "./TrainingSettingsComponent.vue?vue&type=template&id=569621fe&scoped=true"
import script from "./TrainingSettingsComponent.vue?vue&type=script&lang=js"
export * from "./TrainingSettingsComponent.vue?vue&type=script&lang=js"

import "./TrainingSettingsComponent.vue?vue&type=style&index=0&id=569621fe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-569621fe"]])

export default __exports__